// extracted by mini-css-extract-plugin
export var subheadline = "styles-module--subheadline--2a5RG";
export var headline = "styles-module--headline--24e-a";
export var wrapper = "styles-module--wrapper--dR2-f";
export var items = "styles-module--items--68Gm5";
export var item = "styles-module--item--31A0-";